import {Session} from '@auth/core/types';
import {WritableAtom, atom} from 'nanostores';

/**
 * @interface IAuthSession
 * @field user - Authenticated user details. Contains a property "id" that corresponds to the user ID from the database. Value format: 'auth0|{database_user_ID}'
 * @field expires - Duration of user session.
 * @field accessToken - Generated JWT access token.
 * @field exp - Duration of access token.
 */

export interface IAuthSession extends Session {
  accessToken: string;
  exp: number;
}

export const $authSession: WritableAtom<IAuthSession | null> = atom(null);

export const $authUserPermissions: WritableAtom<string[]> = atom([]);
